import { graphql } from 'react-relay';

export const checkNeedPaymentCardQuery = graphql`
  query checkNeedPaymentCardQuery($refundId: String!) {
    checkNeedPaymentCard(refundId: $refundId) {
      result
      errors {
        code
        message
      }
    }
  }
`;
